import {ApplicationConfig, InjectionToken, isDevMode, Provider, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import MyPreset from './mypreset'

import {routes} from './app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {providePrimeNG} from 'primeng/config';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {
    Environment,
    ErrorHandlerInjectionToken,
    isNullOrUndefined,
    ProgressSpinnerService,
    provideCoreLibrary
} from '@abydos-angular/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {PrimeNGMessageErrorHandler} from './abydos-error-handler';
import {provideStore} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {appInitialReducerMap, appInitialState, appMetaReducers} from './store/app.reducers';
import {
    AuthFacade,
    provideAuth,
    provideCategory,
    provideCountry,
    provideSettlement,
    provideZipCode,
    TokenInterceptor
} from '@abydos-angular/rest-api';
import {provideActivity} from './activity/activity.module';
import {provideEvent} from './event/event.module';
import {providePartnerClient} from './partner-client/partner-client.module';
import {provideAbydosForm} from '@abydos-angular/form';
import {provideApplication} from './rest-api/application/application.module';
import {MessageService} from 'primeng/api';
import {provideAbydosPrimeNGLibrary} from '@abydos-angular/primeng';

function provideCoreLibraryWithPlatform(): Provider[] {
    const DEV_SERVER = 'https://booking4k.sightspot.hu';
    // const DEV_SERVER = 'https://booking4k.unideb.hu';
    // const DEV_SERVER = 'http://feco_pc:8080';
    const BASE_URL = DEV_SERVER;
    const CONTEXT = '/rest/';
    const environment = {
        production: !isDevMode(),
        frontendVersion: '1.0.0',
        get baseURL() {
            return isDevMode() || isNullOrUndefined(window) ? DEV_SERVER : window.location.origin;
        },
        context: CONTEXT,
        get restURL() {
            return this.baseURL + CONTEXT;
        },
        get tokenEndpoint() {
            return this.baseURL + CONTEXT + 'oauth2/token';
        },
        get documentDisplayUrl() {
            return this.baseURL + CONTEXT + 'booking/displayDocument';
        },
        webClientId: 'booking_general',
        webClientSecret: '7wtGs7PalkCvxmgAvxmlPohaj64Drazjl98Hi',
        defaultUser: '',
        defaultPassword: '',
        disableAuthRoutes: false,
        provideTableApiService: false,
        appThemeKey: 'unideb-booking',
        versionConfig: {
            detectInterval: 60000,
            backend: 'hu.unideb.booking.rest',
            frontend: 'hu.unideb.booking.web.user',
        },
    }
    return [
            provideCoreLibrary(environment as Environment),
        { provide: EnvironmentInjectionToken, useValue: environment}
    ];
}

export const EnvironmentInjectionToken = new InjectionToken<Environment>('Environment Injection Token');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes),
        provideClientHydration(withEventReplay()),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
        providePrimeNG({
            translation: {
                firstDayOfWeek: 1,
                monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
                monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
                dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
                dayNamesShort: ['V.', 'H.', 'K.', 'Sze.', 'Cs.', 'P.', 'Szo.'],
                dayNamesMin: ['V.', 'H.', 'K.', 'Sze.', 'Cs.', 'P.', 'Szo.'],
                today: 'Ma',
                clear: 'Töröl',
                dateFormat: 'yy.mm.dd',
                weekHeader: 'Hét',
                emptySearchMessage: 'Nincs megjeleníthető elem',
                emptyMessage: 'Nincs választható elem'
            },
            theme: {
                preset: MyPreset,
                options: {
                    darkModeSelector: '.dark-mode',
                    cssLayer: {
                        name: 'primeng',
                        order: 'app-styles, primeng'
                    }
                }
            }
        }),
        {
            provide: ErrorHandlerInjectionToken,
            useFactory: (messageService: MessageService) => {
                return new PrimeNGMessageErrorHandler(messageService);
            },
            deps: [MessageService]
        }
        , provideCoreLibraryWithPlatform()
        , provideAbydosPrimeNGLibrary()
        , provideZipCode()
        , provideSettlement()
        , provideCountry()
        , provideApplication()
        , ProgressSpinnerService
        , provideActivity()
        , provideEvent()
        , providePartnerClient()
        , provideCategory()
        , provideAbydosForm()
        , provideAuth({
            title: 'UNIDEB BOOKING',
            subTitle: 'Hallgatói modul',
            loginIdTitle: 'Egyetemi azonosító (eduID)',
            loginErrorMessage: 'Hibás felhasználó azonosító és/vagy jelszó!',
            loginScope: 'GENERAL_USER',
            oAuthLoginMode: () => {
                return false;
            },
            onRouteWithRole: (role: string, authFacade: AuthFacade) => {
                return '/landing'
            }
        })
        , provideStore(appInitialReducerMap, {initialState: appInitialState, metaReducers: appMetaReducers})
        , provideEffects([])
    ],
};
